import { motion } from "framer-motion";

const images = [
    {
        url: "https://images.pexels.com/photos/12251080/pexels-photo-12251080.jpeg",
        alt: "Modern dental office interior",
        span: "md:col-span-2 md:row-span-2",
    },
    {
        url: "https://images.unsplash.com/photo-1589554881701-3902036d4d04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjbGluaWMlMjBpbnRlcmlvciUyMGJyaWdodHxlbnwwfHx8fDE3Nzc2MzczMTF8MA&ixlib=rb-4.1.0&q=85",
        alt: "Modern waiting area",
        span: "",
    },
    {
        url: "https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?q=80&w=1200&auto=format&fit=crop",
        alt: "Skincare treatment",
        span: "",
    },
    {
        url: "https://images.unsplash.com/photo-1629909613654-28e377c37b09?q=80&w=1200&auto=format&fit=crop",
        alt: "Dental equipment",
        span: "md:col-span-2",
    },
    {
        url: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?q=80&w=1200&auto=format&fit=crop",
        alt: "Modern dermatology tools",
        span: "",
    },
];

export default function Gallery() {
    return (
        <section
            id="gallery"
            className="py-24 md:py-32 bg-[#F3F1EC]/60"
            data-testid="gallery-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.6 }}
                    className="flex flex-col md:flex-row md:items-end md:justify-between gap-6"
                >
                    <div className="max-w-2xl">
                        <span className="text-xs uppercase tracking-[0.3em] text-[#8A9A5B] font-medium">
                            — Inside Mirrari
                        </span>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light text-[#1A221F] mt-4 leading-[1.1] tracking-tight">
                            Calm, bright, <em className="italic text-[#3B5249]">built for comfort.</em>
                        </h2>
                    </div>
                    <p className="text-[#4A5D54] md:max-w-sm">
                        A closer look at the space where your treatments happen — thoughtful
                        design that quiets the nerves.
                    </p>
                </motion.div>

                <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-4 md:gap-5 mt-14">
                    {images.map((img, i) => (
                        <motion.figure
                            key={i}
                            initial={{ opacity: 0, scale: 0.96 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true, margin: "-50px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            className={`overflow-hidden rounded-3xl bg-white group ${img.span}`}
                            data-testid={`gallery-item-${i}`}
                        >
                            <img
                                src={img.url}
                                alt={img.alt}
                                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]"
                            />
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
